import Typography from '@/components/UI/typography/Typography'
import useCountDown from '@/hooks/useCountDown'
import { FC, useEffect } from 'react'

interface CountDownTimerProps {
  onReset: () => void
}

const CountDownTimer: FC<CountDownTimerProps> = ({ onReset }) => {
  const { counter, start, reset } = useCountDown(60)

  useEffect(() => {
    start()
  }, [])

  const handleResend = () => {
    if (!counter) {
      reset()
      start()
      onReset()
    }
  }

  const secondsToMinutes = counter => {
    return `${(counter % 60).toString().padStart(2, '0')} : ${Math.floor(
      counter / 60,
    )
      .toString()
      .padStart(2, '0')}`
  }

  return (
    <Typography
      variant="bodyS"
      color={!counter ? 'primary_main' : 'neutral_700'}
      onClick={handleResend}
    >
      {!counter ? 'ارسال مجدد' : secondsToMinutes(counter)}
    </Typography>
  )
}

export default CountDownTimer
